/**
 * index
 */
import './chart/bar';
import './chart/line';
import './chart/area';
import './chart/pie';
import './chart/scatter';
import './chart/funnel';
import './chart/gauge';
import './chart/wordCloud';
import './chart/wordCloudFast';
import './chart/treemap';
import './chart/map';
import './chart/demand';
import './chart/liquid';
import './chart/sankey';
import './chart/heatmap';
import './chart/waterfall';
import './chart/sunburst';
import './chart/candlestick';
import './chart/streamgraph';
// import './chart/tgi';
// import './chart/gantt';
// import './chart/venn';
// import './chart/tree';
// import './chart/graph';
import './component/tooltip';
import './component/title';
import './component/legend';
import './component/slider';
import './component/dataZoom';
import './component/brush';
import './component/colorLegend';
import './component/dataMarker';
import './component/calendar';
// import './component/amap';
import './scale/time';
import { use } from './utils/installable';
import { PaintInWorker } from './features';
export * from './core';
use(PaintInWorker);
